import React, { useEffect, useState } from "react";
import defaultImage from "../../assets/images/1.jpg";
// import { fetchMenu } from "../../config/api/api";
import Data from '../../assets/data/data'
import { Link, useParams } from "react-router-dom";

const ContinentalMenu = () => {
  const [menu, setMenu] = useState(null);

  const { types } = useParams();
  useEffect(() => {
    const getMenus = async () => {
      const data = Data.find((item)=>item.menu)
      if (data && data.menu && data.menu.length > 0) {
        setMenu(data);
      }
    };
    getMenus();
  }, [types]);
  return (
    <div className="py-14 px-5 sm:px-14 md:px-16 lg:px-20 bg-slate-100">
      <div className="text-center font-semibold text-2xl lg:text-4xl font-fairDisplay mb-8">
        Classy Cafe Menu
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {menu && menu.menu
          ? menu.menu.map((val, id) => (
              <Link
                to={`/menu/${val.type.toLowerCase()}`}
                className="rounded-md p-2"
                key={id}
              >
                <div className="flex justify-center">
                  <img
                    src={val.cover_image || defaultImage}
                    alt={val.type}
                    className="w-20 h-20 rounded-full"
                  />
                </div>
                <div className="text-black text-center font-bold my-3">{val.title}</div>
              </Link>
            ))
          : Array.from({ length: 5 }).map((_, idx) => (
              <div
                key={idx}
                className="w-full h-[8em] bg-black rounded-md animate-pulse"
              ></div>
            ))}
      </div>
    </div>
  );
};

export default ContinentalMenu;
